import { NavId } from "types/navigation";

export const SECTION_INDEX_MAP_MOBILE: Record<NavId, number> = {
  [NavId.Section1]: 0,
  [NavId.Section2]: 1,
  [NavId.Section3]: 2,
  [NavId.Section4]: 3,
  [NavId.Section5]: 4,
  [NavId.Section6]: 5,
  [NavId.Section7]: 6,
  [NavId.Section8]: -1,
  [NavId.Section9]: 7,
  [NavId.Section10]: 8,
  [NavId.Section11]: 10,
};
